import { render, staticRenderFns } from "./TigerLocation.vue?vue&type=template&id=7edfcfe5&scoped=true"
import script from "./TigerLocation.vue?vue&type=script&lang=ts"
export * from "./TigerLocation.vue?vue&type=script&lang=ts"
import style0 from "./TigerLocation.vue?vue&type=style&index=0&id=7edfcfe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edfcfe5",
  null
  
)

export default component.exports